import React, { Fragment, useContext, useEffect, useState } from "react";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField } from "@mui/material";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const RevisionHistory = (props) => {
  const [open, setOpen] = useState(false);
  const [changeDescription, setchangeDescription] = useState("");

  const handleClose = () => {
    if (props.handleCancel) {
      props.handleCancel();
    }
  };

  const handleOk = () => {
    if (props.handleCreate) {
      props.handleCreate(changeDescription);
    }
  };

  useEffect(() => {
    setOpen(props.openDialogBox);
  }, [props.openDialogBox]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
    >
      <DialogTitle id="alert-dialog-title">Description of changes</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          multiline
          rows={4}
          label=""
          value={changeDescription}
          onChange={(e) => setchangeDescription(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0066FF1A",
            color: "#0066FF",
            "&:hover": {
              bgcolor: "#0066FF1A",
              "& .MuiTypography-root": {
                color: "white",
              },
            },
            boxShadow: 0,
            textTransform: "none",
          }}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            boxShadow: 0,
            backgroundColor: "#0066FF",
          }}
          disabled={changeDescription === ""}
          onClick={handleOk}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
